import React from 'react';

const TestimonialsForm = ({ formData, setFormData }) => {

    return (
    <>
    <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Client Full Name *
        </label>
        <input
          type="text"
          placeholder="Name"
          value={formData.name || ''}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Client's Role *
        </label>
        <input
          type="text"
          placeholder="Role"
          value={formData.role || ''}
          onChange={(e) => setFormData({ ...formData, role: e.target.value })}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Client's Feedback *
        </label>
        <textarea
          placeholder="feedback"
          value={formData.feedback || ''}
          onChange={(e) => setFormData({ ...formData, feedback: e.target.value })}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 h-24"
          required
        />
      </div>
    </>
  )
    }

    export default TestimonialsForm;